import { render, staticRenderFns } from "./ChiefQuerylogsDashboard.vue?vue&type=template&id=667d18e0&"
import script from "./ChiefQuerylogsDashboard.vue?vue&type=script&lang=js&"
export * from "./ChiefQuerylogsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports